import { MONTHS_IN_SPANISH } from 'src/app/shared/common/constants';

//date formatted as yyyy-mm-dd
export const formattedTodayYYYYMMDD = () =>
  new Date().toISOString().split('T')[0];

//date as dd/mm/yyyy
export const formattedTodayddmmyyyySlashs = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
export const dateStringToDateType = (date: string): Date => {
  const newDate = new Date(date);
  return newDate;
};
export const getDateformatMonthYearString = (dateToTranslate: Date): string => {
  const monthKey = dateToTranslate.getMonth() as keyof typeof MONTHS_IN_SPANISH;
  const spanishMonth = MONTHS_IN_SPANISH[monthKey];

  return `${spanishMonth} ${dateToTranslate.getFullYear()}`;
};

export const formattedStringDateToddmmyyyySlashs = (date: string): string => {
  const verifyDate = new Date(date);
  if (Number.isNaN(verifyDate.getTime())) {
    return 'Fecha inválida';
  }

  const newDate = date.split('T')[0];
  const [year, month, day] = newDate.split('-');
  const formatedDate = `${day}/${month}/${year}`;

  return formatedDate;
};
//receives a string formatted as 34956.78, returning it as 34.956,78
export const toClpPlusDecimals = (toFormat: string): string => {
  const splitted = toFormat.split('.');
  const beforeDecimalClp = toClp(+splitted[0]);

  return `${beforeDecimalClp},${splitted[1]}`;
};

//chilean currency
export const toClp = (numberToFormat: number): string => {
  let newNumber = numberToFormat
    .toString()
    .split('')
    .reverse()
    .join('')
    .replace(/(?=\d*\.?)(\d{3})/g, '$1.');
  newNumber = newNumber.split('').reverse().join('').replace(/^\.*/, '');

  return newNumber;
};

//20456123K => 20.456.123-K
export const stringToRutFormatted = (rut: string): string => {
  const rutString = rut.toString();
  const rutStringWithDots = toClp(Number(rutString.slice(0, -1)));
  const rutStringWithDotsAndDash = `${rutStringWithDots}-${rutString.slice(
    -1
  )}`;
  return rutStringWithDotsAndDash;
};

export const stringToRutPDFFormatted = (rut: string): string => {
  return `${rut.slice(0, -1)}-${rut.slice(-1)}`;
};

export const truncateTextWithDots = (text: string, maxChars: number) => {
  if (text.length < maxChars) {
    return text;
  }
  return text.slice(0, maxChars) + '...';
};

export const formatRegime = (regime: string) => {
  switch (regime) {
    case 'RTCAV1':
      return 'Anterior';
    case 'RTCAV2':
      return 'General';
    case 'RTCAV3':
      return 'Opcional';
    case 'RTCAV4':
      return 'Opcional B';
    case 'RTCAV5':
      return '54 Bis';
    case 'RTCAV6':
      return 'Exceso 54 Bis';
    case 'RTCAV7':
      return 'Transitorio';
    case 'RTCAV8':
      return 'Retiro 10%';
    case 'A':
      return 'A';
    case 'B':
      return 'B';
    default:
      return 'General';
  }
};
